import {
  List,
} from 'react-admin';
import { AIPromptsCommandPanel } from './AIPromptsCommandPanel';
import AIPromptsTreeView from './AIPromptsTreeView';

export const entityTypes = {
  journalEntries: 'Patient - Journal Entries',
  therapistSessionNotes: 'Therapist - Session Notes',
  therapistLiveNotes: 'Therapist - Live Notes',
  therapistHomework: 'Therapist - Homework',
};

export const outputTypes = [
  'systemMessage',
  'grammar',
  'bullet',
  'singleSentence',
  'tags',
  'title',
  'quickFacts',
] as const;

export const outputTypesChoices = outputTypes.map(id => ({
  id,
  name: id,
}));

/**
 * Output types admins can attach to `subType === 'custom'` session notes.
 * The main note body is the therapist's custom framework text (runtime injects it as `grammar`);
 * there is no separate configurable `grammar` prompt for custom. Excludes bullet/tags/quickFacts/grammar.
 */
export const outputTypesForCustomSessionNotes = outputTypes.filter(
  ot => !['bullet', 'tags', 'quickFacts', 'grammar'].includes(ot),
);

export const outputTypesChoicesForCustomSessionNotes =
  outputTypesForCustomSessionNotes.map(id => ({
    id,
    name: id,
  }));

export const AIPromptsList = () => (
  <List
    resource="aiPrompts"
    actions={false}
    pagination={false}
    component="div"
    title="Agent Prompts"
  >
    <AIPromptsTreeView />
  </List>
);
